module.exports = __webpack_public_path__ + "img/luz.5af071ca.svg";